class Extract_Original_Variable {
    static path = 'variables/extract-original-variable';

    constructor(mutator){
        this.addInput("Source", "pinned");
        this.addOutput("", "");
        this.bgcolor = '#f5967d';
        this.title = 'Extract Original Data';
        this.desc = 'Extract original data from an updated object';
        this.properties = {selected: '', options: [], xTypes: {}, parentProperties: {}};
    }

    onConnectionsChange(type) {
        if(type === 1) { //LiteGraph.INPUT
            let parent_node = this.getParentNode();
            this.widgets = [];
            this.properties.options = [];
            this.properties.xTypes = {};

            if (!parent_node) {
                this.title = 'Extract Original'
                this.outputs[0].name = '';
                this.outputs[0].type = '';
                this.properties.parentProperties = {};
                this.properties.xTypes = {}
                return;
            }

            let properties = parent_node.properties.modelProperties && parent_node.properties.modelProperties.properties && Object.keys(parent_node.properties.modelProperties.properties).length > 0 ? parent_node.properties.modelProperties.properties : false;
            if (properties) {
                this.properties.parentProperties = parent_node.properties.modelProperties || {}
                Object.keys(properties).forEach((prop) => {
                    this.properties.options.push(prop);
                    this.properties.xTypes[prop] = properties[prop].type;
                });
            }

            this.setupPropertySelectionWidget();
        }
    }

    setupPropertySelectionWidget() {
        this.addWidget("combo","",this.properties.selected,(v) => {
            this.properties.selected = v;
            if(v !== '') {
                this.title = '[Original] ' + v.replace(/_/g, ' ');
                this.outputs[0].name = v.replace(/_/g, ' ') || '';
                this.outputs[0].type = this.properties.xTypes[v] || ''
            } else {
                this.title = 'Extract Original'
                this.outputs[0].name = '';
                this.outputs[0].type = '';
            }
            this.triggerSlot(0, v);
        },{ property: "selected", values: this.properties.options } );
    }
}

module.exports = Extract_Original_Variable
